import Axios, { AxiosResponse } from "axios"
import { v4 as uuidv4 } from "uuid";
import { GET_ATU, GET_DAILY_REPORT } from "./constants";
// 
import type { SimpleResponse } from "@hitit/api";
import type { DailyReport, GetATU } from "./types";
type R<T> = Promise<AxiosResponse<T>>;

const BASE_URL = "HITIT_BACKEND_URL";

export const axios = Axios.create({
    baseURL: BASE_URL,
    headers: {
        DEVICETYPE: "web",
        DEVICEUUID: uuidv4(),
        CLIENTVERSION: "7.0.0",
        DEVICELANGUAGE: "ko",
    },
});

export function getDailyReport(token: string): R<SimpleResponse<DailyReport>> {
    return axios.get(GET_DAILY_REPORT, {
        params: { token }
    })
}

export function getAtu(token: string): R<SimpleResponse<GetATU>> {
    return axios.get(GET_ATU, {
        params: { token }
    })
}

export function postAtu(token: string, id: string, storeId: string, ansAppTempUnlockResponseType: string): R<SimpleResponse<GetATU>> {
    return axios.post(GET_ATU, {
        id,
        storeId,
        ansAppTempUnlockResponseType,
    }, {
        params: token
    })
}
